export default function Reviews() {
  return (
    <section className="py-20 px-6 max-w-4xl mx-auto text-center" data-testid="reviews-section">
      <div className="p-8 rounded-2xl bg-[#121216] gold-border">
        <span className="text-xs font-mono uppercase tracking-widest text-[#d4af37] block mb-2">Verified DFW Projects</span>
        <h2 className="font-display text-2xl uppercase text-white mb-3">Client Verifications &amp; Project Logs</h2>
        <p className="text-xs text-zinc-400 max-w-md mx-auto leading-relaxed">
          Client project reviews and low-voltage field verification reports from our Dallas–Fort Worth installations will be posted here.
        </p>
      </div>
    </section>
  );
}
